// import React, { useEffect, useState } from "react";
// import Table from "../components/Table/Table";
// import { saveAs } from "file-saver";
// import DownloadIcon from "@mui/icons-material/Download";
// import { Tabs, Tab, TablePagination, CircularProgress } from "@mui/material";
// import axios from "axios";
// import * as XLSX from "xlsx";

// const FlashData = () => {
//   const [activeTab, setActiveTab] = useState("tab1");
//   const [tableData1, setTableData1] = useState([]);
//   const [tableData2, setTableData2] = useState([]);
//   const [tableHeader, setTableHeader] = useState([]);
//   const [fileList, setFileList] = useState([]);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Pagination states for main tables
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   // Pagination states for file selection table
//   const [filePage, setFilePage] = useState(0);
//   const [fileRowsPerPage, setFileRowsPerPage] = useState(5);
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   const projectId = localStorage.getItem("selectedProject");

// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${baseURL}get_file_names?projectId=${projectId}`
//       );

//       const supplierFiles = [];
//       const suppliers = response.data.suppliers;
//       Object.keys(suppliers).forEach((supplierName) => {
//         suppliers[supplierName].pdi_files.forEach((file) => {
//           supplierFiles.push({
//             file: {
//               download_url: file.download_url,
//               file_path: file.file_path,
//               last_modified: file.last_modified,
//             },
//             supplierName,
//           });
//         });
//       });

//       setFileList(supplierFiles);

//       const headers = [
//         { dbParam: "Pallet_No", displayName: "Pallet No" },
//         { dbParam: "Module_No", displayName: "Module Serial No" },
//         { dbParam: "Pmax", displayName: "Pmax" },
//         { dbParam: "Voc", displayName: "Voc" },
//         { dbParam: "Isc", displayName: "Isc" },
//         { dbParam: "Vmp", displayName: "Vmpp" },
//         { dbParam: "Imp", displayName: "Imp" },
//         { dbParam: "FF", displayName: "FF" },
//         { dbParam: "Efficiency (%)", displayName: "Efficiency (%)" },
//         { dbParam: "Flash_Date", displayName: "Flash Date" },
//         { dbParam: "Line", displayName: "Line Code" },
//         { dbParam: "Binning", displayName: "Binning" },
//         { dbParam: "Model", displayName: "Model" },
//         { dbParam: "Junction Box", displayName: "Junction Box" },
//         { dbParam: "No.", displayName: "Quantity" },
//         { dbParam: "inserted_by", displayName: "Inserted By" },
//         { dbParam: "inserted_time", displayName: "Inserted Time" },
//         { dbParam: "project_id", displayName: "Project ID" },
//         { dbParam: "supplier_name", displayName: "Supplier" },
//         { dbParam: "updated_by", displayName: "Updated By" },
//         { dbParam: "updated_time", displayName: "Updated Time" },
//         { dbParam: "Bus Bar", displayName: "Bus Bar" },
//         { dbParam: "Customer Name", displayName: "Customer" },
//         { dbParam: "GW", displayName: "GW" },
//         { dbParam: "Grade", displayName: "Grade" },
//         { dbParam: "Location Name", displayName: "Location" },
//         { dbParam: "Order Number", displayName: "Order Number" },
//         { dbParam: "Power Name", displayName: "Power" },
//         { dbParam: "Wp", displayName: "Watt Peak (Wp)" },
//       ];

//       setTableHeader(headers);
//       setTableData1([]);
//       setTableData2([]);
//     } catch (error) {
//       console.error("Error fetching data from API", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchData();
// }, [projectId]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

// // Update useEffect for fetching tab data to send full file names
// useEffect(() => {
//     const fetchDataForTab = async () => {
//       if (selectedFiles.length === 0) {
//         setTableData1([]);
//         setTableData2([]);
//         return;
//       }

//       // Find the first selected file's full path to extract the date
//       const firstSelectedFile = fileList.find(({ file }) =>
//         selectedFiles.includes(file.file_path.split("/").pop().replace(/^\d{4}-\d{2}-\d{2}-/, ""))
//       )?.file.file_path;

//       if (!firstSelectedFile) {
//         console.error("Selected file not found in fileList");
//         return;
//       }

//       // Extract date from the full filename (with path)
//       const date = firstSelectedFile.split("/").pop().split("-").slice(0, 3).join("-");
      
//       if (!date.match(/^\d{4}-\d{2}-\d{2}$/)) {
//         console.error("Invalid date format in filename");
//         return;
//       }

//       const projectId = localStorage.getItem("selectedProject");

//       try {
//         setLoading(true);

//         const payload = {
//           date,
//           projectId,
//           filenames: selectedFiles, // Contains filenames without date prefix
//         };

//         console.log("Sending payload:", payload); // For debugging

//         if (activeTab === "tab1") {
//           const response = await axios.post(
//             `${baseURL}get_pdi_data`,
//             payload
//           );
//           setTableData1(response.data.records);
//         } else if (activeTab === "tab2") {
//           const response = await axios.post(
//             `${baseURL}match_pdi`,
//             payload
//           );
//           setTableData2(response.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching data for the selected files", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDataForTab();
//   }, [activeTab, selectedFiles, fileList]);

//   const handleDownload = () => {
//     if (activeTab === "tab2" && tableData2.length > 0) {
//       // Create a new array with mapped data to match tableHeader display names and order
//       const formattedData = tableData2.map((row) => {
//         const newRow = {};
//         tableHeader.forEach((header) => {
//           // Map dbParam to displayName, use the value from row if it exists, otherwise empty string
//           newRow[header.displayName] = row[header.dbParam] ?? "";
//         });
//         return newRow;
//       });

//       // Create worksheet from formatted data
//       const worksheet = XLSX.utils.json_to_sheet(formattedData, {
//         header: tableHeader.map((h) => h.displayName), // Ensure columns are in the order of tableHeader
//       });

//       // Create workbook and append the worksheet
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Mismatch Data");

//       // Generate Excel file and trigger download
//       const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//       const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//       saveAs(blob, "Mismatch_Data.xlsx");
//     }
//   };

//   // Pagination handlers for main tables
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Pagination handlers for file selection table
//   const handleFilePageChange = (event, newPage) => {
//     setFilePage(newPage);
//   };

//   const handleFileRowsPerPageChange = (event) => {
//     setFileRowsPerPage(parseInt(event.target.value, 10));
//     setFilePage(0);
//   };

//   const paginatedData1 = (tableData1 || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
//   const paginatedData2 = (tableData2 || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

// const paginatedFileList = fileList
//   .map(({ file, supplierName }) => {
//     const filenameWithPath = file.file_path.split("/").pop(); // Get filename with date prefix
//     const filename = filenameWithPath.replace(/^\d{4}-\d{2}-\d{2}-/, ""); // Remove date prefix
//     return {
//       Select: (
//         <input
//           type="checkbox"
//           value={filename} // Use filename without date prefix
//           onChange={(e) => {
//             const newSelectedFiles = e.target.checked
//               ? [...selectedFiles, e.target.value].slice(0, 2) // Limit to max 2
//               : selectedFiles.filter((f) => f !== e.target.value);
//             if (newSelectedFiles.length <= 2) {
//               setSelectedFiles(newSelectedFiles);
//             }
//           }}
//           checked={selectedFiles.includes(filename)}
//           disabled={!selectedFiles.includes(filename) && selectedFiles.length >= 2}
//           className="form-checkbox h-5 w-5 text-blue-600 focus:ring-0"
//         />
//       ),
//       FileName: filename, // Display filename without date prefix
//       SupplierName: supplierName,
//     };
//   })
//   .slice(filePage * fileRowsPerPage, filePage * fileRowsPerPage + fileRowsPerPage);

//   return (
//     <div className="space-y-8 p-4 bg-white shadow-lg rounded-lg">
//       <div className="w-full text-center border-b-2 pb-4">
//         <div className="font-semibold text-lg sm:text-xl text-gray-700">PDI Verification</div>
//       </div>
//       <div className="w-full mb-6">
//         <div className="flex justify-between items-center mb-4">
//           <Tabs
//             value={activeTab}
//             onChange={handleTabChange}
//             textColor="primary"
//             indicatorColor="primary"
//           >
//             <Tab value="tab1" label="PDI" />
//             <Tab value="tab2" label="Mismatch Serial No" />
//           </Tabs>
//           {activeTab === "tab2" && (
//             <button
//               onClick={handleDownload}
//               className="text-white bg-[#424752] hover:bg-gray-500 px-4 py-2 rounded-lg flex items-center"
//             >
//               <DownloadIcon style={{ fontSize: 28 }} />
//               <span className="ml-2">Download</span>
//             </button>
//           )}
//         </div>
//         {activeTab === "tab1" && (
//           <div className="bg-gray-100 rounded-lg shadow-lg p-4">
//             <div className="text-gray-700 font-semibold mb-4">Select File:</div>
//             <Table
//               tableHeaders={[
//                 { dbParam: "Select", displayName: "Select" },
//                 { dbParam: "SupplierName", displayName: "Supplier Name" },
//                 { dbParam: "FileName", displayName: "File Name" },
//               ]}
//               tableData={paginatedFileList}
//             />
//             {fileList.length > 0 && (
//               <TablePagination
//                 component="div"
//                 count={fileList.length}
//                 page={filePage}
//                 onPageChange={handleFilePageChange}
//                 rowsPerPage={fileRowsPerPage}
//                 onRowsPerPageChange={handleFileRowsPerPageChange}
//               />
//             )}
//           </div>
//         )}
//       </div>

//       <div className="overflow-x-auto bg-gray-50 rounded-lg p-4">
//         {loading ? (
//           <div className="flex justify-center items-center h-48">
//             <CircularProgress />
//           </div>
//         ) : activeTab === "tab1" && (
//           <>
//             {selectedFiles.length === 0 ? (
//               <div className="text-center text-gray-500">
//                 Please select a file to view the data.
//               </div>
//             ) : paginatedData1.length === 0 ? (
//               <div className="text-center text-gray-500">
//                 No records found for the selected file.
//               </div>
//             ) : (
//               <>
//                 <Table tableHeaders={tableHeader} tableData={paginatedData1} />
//                 {paginatedData1.length > 0 && (
//                   <TablePagination
//                     component="div"
//                     count={tableData1.length}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     rowsPerPage={rowsPerPage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                   />
//                 )}
//               </>
//             )}
//           </>
//         )}
//         {activeTab === "tab2" && (
//           <>
//             {paginatedData2.length === 0 ? (
//               <div className="text-center text-gray-500">
//                 No records found for the selected file.
//               </div>
//             ) : (
//               <>
//                 <Table tableHeaders={tableHeader} tableData={paginatedData2} />
//                 {paginatedData2.length > 0 && (
//                   <TablePagination
//                     component="div"
//                     count={tableData2.length}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     rowsPerPage={rowsPerPage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                   />
//                 )}
//               </>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FlashData;

import React, { useEffect, useState } from "react";
import Table from "../components/Table/Table";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { Tabs, Tab, TablePagination, CircularProgress } from "@mui/material";
import axios from "axios";
import * as XLSX from "xlsx";
import apiClient from "./keycloak/axiosInstance";

const FlashData = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allowedSuppliers, setAllowedSuppliers] = useState([]); // New: filtered suppliers based on roles

  // Pagination states for main tables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Pagination states for file selection table
  const [filePage, setFilePage] = useState(0);
  const [fileRowsPerPage, setFileRowsPerPage] = useState(5);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const projectId = localStorage.getItem("selectedProject");

  // New: Filter suppliers based on user roles
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (!storedRoles) {
      setAllowedSuppliers([]);
      return;
    }

    let userRoles = [];
    try {
      const parsed = JSON.parse(storedRoles);
      if (Array.isArray(parsed)) userRoles = parsed;
      else userRoles = storedRoles.split(",").map(r => r.trim());
    } catch {
      userRoles = storedRoles.split(",").map(r => r.trim());
    }

    // Extract supplier names from roles like: 11111_warree_view, project_rayzon_edit
    const suppliersFromRoles = userRoles
      .map(role => {
        const match = role.toLowerCase().match(/_([^_]+)_(view|edit|upload|admin)/i);
        return match ? match[1].toLowerCase() : null;
      })
      .filter(Boolean);

    // If no supplier-specific roles, show all suppliers (or restrict entirely if preferred)
    if (suppliersFromRoles.length === 0) {
      setAllowedSuppliers([]);
      return;
    }

    const uniqueAllowed = [...new Set(suppliersFromRoles)];
    setAllowedSuppliers(uniqueAllowed);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get(
          `get_file_names?projectId=${projectId}`
        );

        const supplierFiles = [];
        const suppliers = response.data.suppliers;
        Object.keys(suppliers).forEach((supplierName) => {
          // Only include suppliers the user is allowed to see
          if (allowedSuppliers.includes(supplierName.toLowerCase())) {
            suppliers[supplierName].pdi_files.forEach((file) => {
              supplierFiles.push({
                file: {
                  download_url: file.download_url,
                  file_path: file.file_path,
                  last_modified: file.last_modified,
                },
                supplierName,
              });
            });
          }
        });

        setFileList(supplierFiles);

        const headers = [
          { dbParam: "Pallet_No", displayName: "Pallet No" },
          { dbParam: "Module_No", displayName: "Module Serial No" },
          { dbParam: "Pmax", displayName: "Pmax" },
          { dbParam: "Voc", displayName: "Voc" },
          { dbParam: "Isc", displayName: "Isc" },
          { dbParam: "Vmp", displayName: "Vmpp" },
          { dbParam: "Imp", displayName: "Imp" },
          { dbParam: "FF", displayName: "FF" },
          { dbParam: "Efficiency (%)", displayName: "Efficiency (%)" },
          { dbParam: "Flash_Date", displayName: "Flash Date" },
          { dbParam: "Line", displayName: "Line Code" },
          { dbParam: "Binning", displayName: "Binning" },
          { dbParam: "Model", displayName: "Model" },
          { dbParam: "Junction Box", displayName: "Junction Box" },
          { dbParam: "No.", displayName: "Quantity" },
          { dbParam: "inserted_by", displayName: "Inserted By" },
          { dbParam: "inserted_time", displayName: "Inserted Time" },
          { dbParam: "project_id", displayName: "Project ID" },
          { dbParam: "supplier_name", displayName: "Supplier" },
          { dbParam: "updated_by", displayName: "Updated By" },
          { dbParam: "updated_time", displayName: "Updated Time" },
          { dbParam: "Bus Bar", displayName: "Bus Bar" },
          { dbParam: "Customer Name", displayName: "Customer" },
          { dbParam: "GW", displayName: "GW" },
          { dbParam: "Grade", displayName: "Grade" },
          { dbParam: "Location Name", displayName: "Location" },
          { dbParam: "Order Number", displayName: "Order Number" },
          { dbParam: "Power Name", displayName: "Power" },
          { dbParam: "Wp", displayName: "Watt Peak (Wp)" },
        ];

        setTableHeader(headers);
        setTableData1([]);
        setTableData2([]);
      } catch (error) {
        console.error("Error fetching data from API", error);
      } finally {
        setLoading(false);
      }
    };

    if (allowedSuppliers.length > 0 || allowedSuppliers.length === 0) {
      fetchData();
    }
  }, [projectId, allowedSuppliers]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Update useEffect for fetching tab data to send full file names
  useEffect(() => {
    const fetchDataForTab = async () => {
      if (selectedFiles.length === 0) {
        setTableData1([]);
        setTableData2([]);
        return;
      }

      // Find the first selected file's full path to extract the date
      const firstSelectedFile = fileList.find(({ file }) =>
        selectedFiles.includes(file.file_path.split("/").pop().replace(/^\d{4}-\d{2}-\d{2}-/, ""))
      )?.file.file_path;

      if (!firstSelectedFile) {
        console.error("Selected file not found in fileList");
        return;
      }

      // Extract date from the full filename (with path)
      const date = firstSelectedFile.split("/").pop().split("-").slice(0, 3).join("-");

      if (!date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        console.error("Invalid date format in filename");
        return;
      }

      const projectId = localStorage.getItem("selectedProject");

      try {
        setLoading(true);

        const payload = {
          date,
          projectId,
          filenames: selectedFiles, // Contains filenames without date prefix
        };

        console.log("Sending payload:", payload); // For debugging

        if (activeTab === "tab1") {
          const response = await apiClient.post(
            `get_pdi_data`,
            payload
          );
          setTableData1(response.data.records);
        } else if (activeTab === "tab2") {
          const response = await apiClient.post(
            `match_pdi`,
            payload
          );
          setTableData2(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data for the selected files", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDataForTab();
  }, [activeTab, selectedFiles, fileList]);

  const handleDownload = () => {
    if (activeTab === "tab2" && tableData2.length > 0) {
      // Create a new array with mapped data to match tableHeader display names and order
      const formattedData = tableData2.map((row) => {
        const newRow = {};
        tableHeader.forEach((header) => {
          // Map dbParam to displayName, use the value from row if it exists, otherwise empty string
          newRow[header.displayName] = row[header.dbParam] ?? "";
        });
        return newRow;
      });

      // Create worksheet from formatted data
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        header: tableHeader.map((h) => h.displayName), // Ensure columns are in the order of tableHeader
      });

      // Create workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Mismatch Data");

      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, "Mismatch_Data.xlsx");
    }
  };

  // Pagination handlers for main tables
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Pagination handlers for file selection table
  const handleFilePageChange = (event, newPage) => {
    setFilePage(newPage);
  };

  const handleFileRowsPerPageChange = (event) => {
    setFileRowsPerPage(parseInt(event.target.value, 10));
    setFilePage(0);
  };

  const paginatedData1 = (tableData1 || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const paginatedData2 = (tableData2 || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const paginatedFileList = fileList
    .map(({ file, supplierName }) => {
      const filenameWithPath = file.file_path.split("/").pop(); // Get filename with date prefix
      const filename = filenameWithPath.replace(/^\d{4}-\d{2}-\d{2}-/, ""); // Remove date prefix
      return {
        Select: (
          <input
            type="checkbox"
            value={filename} // Use filename without date prefix
            onChange={(e) => {
              const newSelectedFiles = e.target.checked
                ? [...selectedFiles, e.target.value].slice(0, 2) // Limit to max 2
                : selectedFiles.filter((f) => f !== e.target.value);
              if (newSelectedFiles.length <= 2) {
                setSelectedFiles(newSelectedFiles);
              }
            }}
            checked={selectedFiles.includes(filename)}
            disabled={!selectedFiles.includes(filename) && selectedFiles.length >= 2}
            className="form-checkbox h-5 w-5 text-blue-600 focus:ring-0"
          />
        ),
        FileName: filename, // Display filename without date prefix
        SupplierName: supplierName,
      };
    })
    .slice(filePage * fileRowsPerPage, filePage * fileRowsPerPage + fileRowsPerPage);

  return (
    <div className="space-y-8 p-4 bg-white shadow-lg rounded-lg">
      <div className="w-full text-center border-b-2 pb-4">
        <div className="font-semibold text-lg sm:text-xl text-gray-700">PDI Verification</div>
      </div>
      <div className="w-full mb-6">
        <div className="flex justify-between items-center mb-4">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab value="tab1" label="PDI" />
            <Tab value="tab2" label="Mismatch Serial No" />
          </Tabs>
          {activeTab === "tab2" && (
            <button
              onClick={handleDownload}
              className="text-white bg-[#424752] hover:bg-gray-500 px-4 py-2 rounded-lg flex items-center"
            >
              <DownloadIcon style={{ fontSize: 28 }} />
              <span className="ml-2">Download</span>
            </button>
          )}
        </div>
        {activeTab === "tab1" && (
          <div className="bg-gray-100 rounded-lg shadow-lg p-4">
            <div className="text-gray-700 font-semibold mb-4">Select File:</div>
            <Table
              tableHeaders={[
                { dbParam: "Select", displayName: "Select" },
                { dbParam: "SupplierName", displayName: "Supplier Name" },
                { dbParam: "FileName", displayName: "File Name" },
              ]}
              tableData={paginatedFileList}
            />
            {fileList.length > 0 && (
              <TablePagination
                component="div"
                count={fileList.length}
                page={filePage}
                onPageChange={handleFilePageChange}
                rowsPerPage={fileRowsPerPage}
                onRowsPerPageChange={handleFileRowsPerPageChange}
              />
            )}
          </div>
        )}
      </div>

      <div className="overflow-x-auto bg-gray-50 rounded-lg p-4">
        {loading ? (
          <div className="flex justify-center items-center h-48">
            <CircularProgress />
          </div>
        ) : activeTab === "tab1" && (
          <>
            {selectedFiles.length === 0 ? (
              <div className="text-center text-gray-500">
                Please select a file to view the data.
              </div>
            ) : paginatedData1.length === 0 ? (
              <div className="text-center text-gray-500">
                No records found for the selected file.
              </div>
            ) : (
              <>
                <Table tableHeaders={tableHeader} tableData={paginatedData1} />
                {paginatedData1.length > 0 && (
                  <TablePagination
                    component="div"
                    count={tableData1.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </>
            )}
          </>
        )}
        {activeTab === "tab2" && (
          <>
            {paginatedData2.length === 0 ? (
              <div className="text-center text-gray-500">
                Wait for the data to load or no records found for the selected file.
              </div>
            ) : (
              <>
                <Table tableHeaders={tableHeader} tableData={paginatedData2} />
                {paginatedData2.length > 0 && (
                  <TablePagination
                    component="div"
                    count={tableData2.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FlashData;